import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ColorPicker, FieldColorPicker, } from '@dixa/lib-shared-habla';
export function ColorInputField(props) {
    return (_jsxs(FieldColorPicker, Object.assign({}, props, { children: [_jsx(ColorPicker.Sliders, {}), _jsx(ColorPicker.Presets, { presets: props.presetColors }), _jsx(ColorPicker.Input, {})] })));
}
